import Content, {
    ContentProps,
} from '@/features/pos/components/ProductCatalog/parts/ProductList/parts/Product/parts/Content'
import { useConfigurableProductIdActions } from '@/features/pos/contexts/ConfigurableProductId'
import { FC, memo } from 'react'

interface ProductProps extends Omit<ContentProps, 'onPress'> {
    id: string
}

const Product: FC<ProductProps> = ({ id, ...contentProps }) => {
    const { set } = useConfigurableProductIdActions()

    const handlePress = () => set(id)

    return <Content {...contentProps} onPress={handlePress} />
}

export default memo(Product)
